
export const isShortageHost = () => {
  const currentHost = window.location.hostname;
  const domains = [ 'offerdemand.sfda.gov.sa', 'offerdemand.leanstg.io', 'offerdemand.devclan.io' ];

  return domains.includes(currentHost);
};
